module.exports = __webpack_public_path__ + "img/tab-7.567d84bc.png";